module.exports = __webpack_public_path__ + "img/客服01.bad30e9b.svg";